@if (facade.error()) {
<div class="error-container h-100">
  <div class="error-content">
    <mat-icon>error</mat-icon>
    <h2>{{ 'shared.api.errors.default' | translate }}</h2>
  </div>
</div>
} @else {
<div class="dashboard-container container px-2 pb-2 gap-2 h-100">

  @if(currentUser()?.hasPermission(permissions.AUTOPILOT_DEVICES_IMPORT)) {
  <div class="import-section">
    <input type="file" #fileInput [accept]="inputAccept" (change)="onFileSelected($event)" hidden />

    <div class="drop-zone" [class.dragging]="isDragging()" (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)" (drop)="onDrop($event)" (click)="browseFile()">
      <div class="drop-zone-content">
        @if (!selectedFile()) {
        <mat-icon class="upload-icon">cloud_upload</mat-icon>
        <div class="text-content">
          <span class="main-text">{{'app.autopilot_devices.import.drop_title' | translate}}</span>
          <span class="sub-text">{{'app.autopilot_devices.import.file_hint' | translate}}</span>
        </div>
        } @else {
        <mat-icon class="file-icon">description</mat-icon>
        <div class="text-content">
          <span class="file-name">{{ selectedFile()?.name }}</span>
          <span class="sub-text">{{ selectedFile()?.size ?? 0 | number }} bytes</span>
        </div>
        <button mat-icon-button class="remove-btn" (click)="removeFile(); $event.stopPropagation()">
          <mat-icon>close</mat-icon>
        </button>
        }
      </div>
    </div>

    <div class="action-bar">
      <a mat-stroked-button class="history-btn" routerLink="/autopilot-devices/history"
        [matTooltip]="'app.autopilot_devices.history.tooltip' | translate">
        <mat-icon>history</mat-icon>
        <span>{{ 'app.autopilot_devices.history.button' | translate }}</span>
      </a>
      <button mat-flat-button color="primary" class="upload-btn" [disabled]="!selectedFile() || facade.isImporting()"
        (click)="uploadFile()">
        @if (facade.isImporting()) {
        <mat-spinner diameter="20" strokeWidth="3"></mat-spinner>
        } @else {
        <mat-icon>send</mat-icon>
        }
        <span>{{ 'app.autopilot_devices.import.upload_button' | translate }}</span>
      </button>
    </div>
  </div>
  }

  @if(currentUser()?.hasPermission(permissions.AUTOPILOT_DEVICES_READ)) {
  <av-autopilot-devices-table [facade]="facade" (delete)="deleteDevice($event)"></av-autopilot-devices-table>
  }
  
</div>
}